import { UiActions } from '../actions';

import { createReducer, on } from '@ngrx/store';
import { StepsClientTypes, StepsNotClientTypes } from '../../shared/enums';


export interface StepClientState { StepClient: StepsClientTypes | StepsNotClientTypes; }
export const StepClientInitialState: StepClientState = { StepClient: StepsClientTypes.STEP_OFFER};

const _stepsClientReducer = createReducer(
  StepClientInitialState,
  on(UiActions.Navigate, (state: StepClientState, { step }) => ({...state, StepClient: step}))
);

export function stepsClientReducer(state, action) {
  if (action.type === StepsClientTypes.STEP_OFFER) {
    state = StepsClientTypes.STEP_OFFER;
  }
  return _stepsClientReducer(state, action);
}
